






































































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CustomForm from '@/components/custom-form/index.vue'
import TagSelect from '@/components/tag-select/index.vue'
import VipApi from '@/api/vip/list'
import VipTag from '@/api/vip/vipTag/index'
import appconst from '@/lib/appconst'
import MallConfig from '@/api/mall/mallConfig/index'
import CouponSelect from '@/components/coupon-select/index.vue'
@Component({
  components: {
    CustomForm,
    TagSelect,
    CouponSelect
  },
})
export default class MemberList extends AbpBase {
  filters = [
    {
      label: '关键字搜索：',
      type: 'input',
      props: {
        placeholder: '',
      },
      key: 'filter',
    },
    {
      label: '会员标签',
      type: 'select',
      key: 'Tags',
      defaultValue: [],
      props: {
        'max-tag-count': 2,
        multiple: true,
        placeholder: '请选择',
      },
      options: [],
    },
    {
      label: '会员等级',
      type: 'select',
      key: 'Levels',
      defaultValue: [],
      props: {
        'max-tag-count': 2,
        multiple: true,
        placeholder: '请选择',
      },
      options: [],
    },
    {
      label: '注册时间',
      type: 'datetimerange',
      key: 'dateTimeRange',
      props: {
        placeholder: '请选择注册时间范围',
      },
    },
  ]
  columns: any[] = [
    {
      type: 'selection',
      width: 60,
      align: 'center',
    },
    // {
    //   title: '头像',
    //   slot: 'headImgUri',
    //   align: 'center',
    //   width: 80
    // },
    {
      title: '昵称',
      key: 'nickName',
      align: 'center',
      width: 150,
    },
    {
      title: '手机号',
      key: 'phoneNumber',
      align: 'center',
      width: 150,
    },
    {
      title: '等级',
      key: 'level',
      align: 'center',
      width: 100,
    },
    {
      title: '卡号',
      key: 'code',
      align: 'center',
      width: 150,
    },
    {
      title: '生日',
      slot: 'birthDay',
      align: 'center',
      width: 140,
    },
    {
      title: '积分',
      key: 'bonus',
      align: 'center',
      width: 100,
    },
    {
      title: '成长值',
      key: 'growthValue',
      align: 'center',
      width: 100,
    },
    // {
    //   title: '储值',
    //   key: 'balance',
    //   align: 'center',
    //   width: 100
    // },
    {
      title: '注册时间',
      slot: 'creationTime',
      align: 'center',
      width: 140,
    },
    {
      title: '性别',
      key: 'gender',
      align: 'center',
      width: 100,
    },
    {
      title: '最后消费时间',
      slot: 'lastOrderTime',
      align: 'center',
      width: 140,
    },
    {
      title: '累积订单金额',
      key: 'totalAmount',
      align: 'center',
      width: 120,
    },
    {
      title: '标签',
      slot: 'tags',
      align: 'center',
      width: 100,
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      width: 100,
    },
    {
      title: '导购Id',
      key: 'guideCode',
      align: 'center',
      width: 100,
    },
    {
      title: '导购信息',
      key: 'guideInfo',
      align: 'center',
      width: 150,
    },
    {
      title: '导购姓名',
      key: 'guideName',
      align: 'center',
      width: 100,
    },
    {
      title: '直接推荐人',
      key: 'direct',
      align: 'center',
      width: 100,
    },
    {
      title: '间接推荐人',
      key: 'indirect',
      align: 'center',
      width: 100,
    },
    {
      title: '累积收益金额',
      key: 'totalIncome',
      align: 'center',
      width: 120,
    },
    {
      title: '累计推荐销售金额',
      key: 'amountDistribution',
      align: 'center',
      width: 140,
    },
    {
      title: '操作',
      slot: 'action',
      type: 'action',
      width: 200,
      align: 'center',
      fixed: 'right',
    },
  ]
  rechargeValue: any = {
    price: 0,
  }
  rechargeModal: boolean = false
  changeLevelModal: boolean = false
  exporting: boolean = false
  isCheckAll: boolean = false
  loading: boolean = false
  showSendCoupon: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0
  showTag = false
  tagList = []
  uploadUrl = ''
  templateUrl = ''
  uploadTagUrl = ''
  templateTagUrl = ''
  selectedItems: any = []
  selectObj: any = {}
  levelArr: any = []
  level = ''
  selectedUser: any = {}
  couponsList: any = []
  couponColumns: any[] = [
    {
      title: '优惠券名称',
      key: 'name',
      align: 'center',
    },
    {
      title: '有效期',
      key: 'validDate',
      align: 'center',
    },
    {
      title: '操作',
      slot: 'action',
      align: 'center',
    },
  ]

  get selectedCouponItems() {
    let list = []
    if (this.couponsList.length) {
      list = this.couponsList.map((item) => {
        return item.id
      })
    }
    return list
  }

  submitChange(form, valid) {
    if (valid) {
      this.getTableData(form)
    }
  }

  mounted() {
    this.templateUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/VipInfos/TemplateFile`
    this.uploadUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/VipInfos/excel/upload`
    this.uploadTagUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/VipInfos/ImportVipTagFile`
    this.templateTagUrl = `${appconst.remoteServiceBaseUrl}/api/Vip/VipInfos/ImportTemplateFile`
    this.getVipLevels()
    this.getVipTagList()
    this.submitFn()
    this.getConfig('MemberLevelConfig')
  }

  onCouponRowSelected(e: any) {
    this.couponsList = this.couponsList.concat(e)
  }
  // 发券
  sendCoupon(row) {
    this.selectedUser = row
    this.showSendCoupon = true
  }
  // 删除优惠券
  deleteCoupon(row, index) {
    this.couponsList.splice(index, 1)
  }
  // 取消选择
  selectUserCancle() {
    this.showSendCoupon = false
    this.selectedUser = {}
    this.couponsList = []
  }
  // 选择优惠券确认
  selectCouponSure() {
    if (!this.couponsList.length) {
      this.$Notice.warning({ title: '请先选择优惠券' })
      return
    }
    let obj = {
      userIds: [this.selectedUser.id],
      couponIds: this.selectedCouponItems,
    }
    VipApi.sendCouponToUser(obj).then((res) => {
      this.$Notice.success({ title: '发券成功' })
      this.showSendCoupon = false
      this.couponsList = []
      this.selectedUser = {}
    })
  }
  /**
   * 获取设置
   */
  getConfig(key) {
    MallConfig.getMallConfig(key).then((res) => {
      if (res.data && res.data.Items && res.data.Items.length > 0) {
        this.levelArr = res.data.Items
      }
    })
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }
  cancelFn() {
    this.rechargeValue = {
      price: 0,
    }
    this.rechargeModal = false
  }
  saveFn() {
    if (this.rechargeValue.price <= 0) {
      this.$Notice.warning({
        title: '金额必须大于0',
      })
      return
    }
    VipApi.vipBalanceLog(this.selectObj.id, this.rechargeValue.price).then((res) => {
      this.$Notice.success({
        title: '充值成功',
      })
      this.submitFn()
      this.cancelFn()
    })
  }
  Recharge(item) {
    this.selectObj = item
    this.rechargeModal = true
  }
  ChangeLevel(item) {
    this.selectObj = item
    this.changeLevelModal = true
  }

  saveCL() {
    var item = this.levelArr.find((x) => x.Name === this.selectObj.level)
    console.log('等级')
    if (!item) {
      this.$Notice.warning({
        title: '请选择等级',
      })
      return
    }
    console.log(item)
    VipApi.changeLevel(this.selectObj.id, item.Min).then((res) => {
      this.$Notice.success({
        title: '修改成功',
      })
      this.changeLevelModal = false
      this.submitFn()
    })
  }
  /**
   * 获取会员标签
   */
  getVipTagList() {
    VipTag.getAllTagList().then((res) => {
      this.filters.forEach((item) => {
        if (item.key == 'Tags') {
          switch (item.type) {
            case 'select':
              res.data.items = res.data.items.map((child) => {
                return {
                  value: child.value,
                  text: child.name,
                }
              })
              item.options = res.data.items
              break
          }
        }
      })
    })
  }

  /**
   * 获取会员等级列表
   */
  getVipLevels() {
    MallConfig.getMallConfig('MemberLevelConfig').then((res) => {
      if (res.data && res.data.Items && res.data.Items.length > 0) {
        this.filters.forEach((item) => {
          if (item.key == 'Levels') {
            switch (item.type) {
              case 'select':
                let tempArr = res.data.Items.map((child) => {
                  return {
                    value: child.Name,
                  }
                })
                item.options = tempArr
                break
            }
          }
        })
      }
    })
  }

  /**
   * 获取会员列表
   */
  getTableData(form = {}) {
    this.isCheckAll = false
    let filter = form['filter']
    let Tags = form['Tags']
    let Levels = form['Levels']
    let dateTimeRange = form['dateTimeRange'] ? form['dateTimeRange'] : []

    let { pageSize, currentPage } = this
    let published = false
    VipApi.getVipList(
      pageSize,
      currentPage,
      filter,
      Tags,
      Levels,
      dateTimeRange[0] ? dateTimeRange[0] : null,
      dateTimeRange[1] ? dateTimeRange[1] : null
    )
      .then((res) => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  /**
   * 显示标签选择框
   */
  shwoTagFn() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log(selection)
      if (selection.length == 1) {
        this.selectedItems = selection[0].tags
      } else {
        this.selectedItems = []
      }
      this.showTag = !this.showTag
    } else {
      this.$Notice.warning({
        title: '请先选择会员',
      })
    }
  }

  /**
   * 标签分配
   */
  tagChange(e) {
    console.log(e)
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      let userIds = selection.map((item) => {
        return item.id
      })
      VipTag.VipTagUser(e, userIds).then((res) => {
        this.submitFn()
      })
    }
  }

  /**
   * 导出excel表格
   */
  exportExcel() {
    this.exporting = true
    let refForm: any = this.$refs.lineForm
    const form = refForm.getForm()
    let dateTimeRange = form['dateTimeRange']
    console.log(form)
    VipTag.exportBrokerageReportFile(this.pageSize, this.currentPage, dateTimeRange[0], dateTimeRange[1])
      .then((res) => {
        console.log(res)
        this.exporting = false
        this.download(res.data)
      })
      .catch((err) => {
        this.exporting = false
      })
  }
  download(data) {
    if (!data) {
      return
    }
    let url = window.URL.createObjectURL(new Blob([data]))
    let link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.setAttribute('download', '会员列表.xlsx')

    document.body.appendChild(link)
    link.click()
  }
  /**
   * 下载模板
   */
  downloadTemplate() {
    location.href = this.templateUrl
  }
  downloadTemplateTag() {
    location.href = this.templateTagUrl
  }

  /**
   * 导入会员备注
   */
  uploadSuccess(res) {
    this.$Message.success('上传文件成功，导入比较耗时，请稍后刷新查看结果')
    // this.loadData();
    console.log(res)
    this.getTableData()
  }

  /**
   * 标签显示
   */
  tagsString(arr: any[]) {
    return arr.join('，')
  }

  /**
   * 会员详情
   */
  goDetailFn(row) {
    this.$router.push({
      name: 'vipDetail',
      query: {
        id: row.id,
      },
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  /**
   * 积分清零
   */
  clearedFn(state: boolean) {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认将已选中的会员积分清零？',
        onOk: () => {
          let ids = selection.map((item) => {
            return item.id
          })
          VipApi.clearBonus(ids).then((res) => {
            this.submitFn()
          })
        },
      })
    } else {
      this.$Notice.warning({
        title: '请先选择会员',
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.submitFn()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.submitFn()
  }
}
